import React, { type ReactNode } from 'react';

import { Button, type ButtonProps } from '../../../../Button';

import styles from './SelectDropdownActionButton.module.scss';

type SelectDropdownActionButtonProps = {
    children: ReactNode;
} & ButtonProps;

const SelectDropdownActionButton = ({
    children,
    type,
    ...buttonProps
}: SelectDropdownActionButtonProps) => {
    return (
        <div className={styles.container}>
            <Button type={(type as never) ?? 'ghost'} fill shape="square" {...buttonProps}>
                {children}
            </Button>
        </div>
    );
};

export { SelectDropdownActionButton };
